import { gql } from '@apollo/client'
import { JOB_FRAGMENT } from '~/common/apollo/apollo.fragment'
import { JOB_APPLICANT_FRAGMENT } from '../fragments/job.applicant.fragment'

export const SAVE_FILTER_QUERY = gql`
	query SavedFilters {
		savedFilters {
			nodes {
				alertChannels
				enableAlert
				externalId
				filterCondition {
					conditions
					id
				}
				frequency
				id
				lastAlertedAt
				name
				pauseAlert
				pauseAlertPeriod
				pauseAlertUntil
				startPauseAlertDate
				specificScope
			}
			totalCount
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				pageSize
				startCursor
			}
		}
	}
`

export const GET_APPLICATION_JOB_QUERY = gql`
	query getApplicantJobQuery($jobId: String!) {
		job(id: $jobId) {
			...jobApplicantFragment
		}
	}
	${JOB_APPLICANT_FRAGMENT}
`

export const GET_JOB_ALERT_QUERY = gql`
	query JobAlerts($after: String, $before: String, $first: Int, $last: Int) {
		jobAlerts(after: $after, before: $before, first: $first, last: $last) {
			nodes {
				name
				alertChannel
				enableAlert
				filterCondition {
					startDate
					exclusiveJob
					externalId
					locationCities
					locationStates
					jobTypes
					disciplines
					id
					maxWage
					minMatchingPercentage
					minWage
					nearBy
					shifts
					specialties
				}
				frequency
				lastAlertedAt
				name
				pauseAlert
				pauseAlertPeriod
				pauseAlertUntil
				startPauseAlertDate
				jobs {
					...jobFragment
				}
			}
			totalCount
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				pageSize
				startCursor
			}
		}
	}
	${JOB_FRAGMENT}
`

export const GET_ALL_CLOSE_JOB_QUERY = gql`
	query ClosedJobsList($ids: [String!]!) {
		closedJobsList(ids: $ids) {
			id
		}
	}
`
